import { Typography } from '@material-ui/core';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles } from './style/gstheme';
import { isRTL } from './utils/utils';

const styles = () => {
  return Object.assign({
    listResultItem: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between'
    }
  }, globalStyles);
};

class ListResult extends React.Component {

  render() {

    const { classes, onClick, invalid, iri, pendingDeletion, informationOnly, additionalLabel, listSecondIcon, text, clickableInvalid, lang } = this.props;
    const rtl = isRTL(lang);

    return (
      <ListItem
        data-test={invalid ? "list-item-invalid" : "list-item"}
        className={((invalid || pendingDeletion || informationOnly) && !clickableInvalid) ?
          (informationOnly ?
            classes.infoResult
            :
            classes.invalidResult
          )
          :
          classes.result}
        dir={rtl ? "rtl" : null}
        style={{ ...(rtl) && { textAlign: 'right' } }}>
        <ListItemText className={classes.resultText}
          primary={
            <div className={classes.listResultItem}>
              <div style={{ width: '100%' }}>
                <Typography data-test="result-text" variant="body2">
                  <Tooltip
                    title={iri || text}
                    PopperProps={{
                      "data-test": "result-tip"
                    }}
                  >
                    <span data-test="result-text-words" style={{ wordWrap: 'break-word' }}>{text}</span>
                  </Tooltip>
                </Typography>
                {(additionalLabel || pendingDeletion) &&
                  <div>
                    {additionalLabel && !pendingDeletion && <Typography data-test="additional" variant="caption">{additionalLabel}</Typography>}
                    {pendingDeletion &&
                      <div>
                        <Typography data-test="caption" variant="caption">This is pending deletion and will be removed shortly.</Typography>
                        <Typography variant="caption">Once removed the IRI becomes available for reuse.</Typography>
                      </div>}
                  </div>
                }
              </div>
              <div
                data-test="second-icon"
                className={classes.resultSecondIcon}
                style={{ ...(rtl) && { textAlign: 'left' } }}>
                {listSecondIcon}
              </div>
            </div>
          }
          onClick={!informationOnly ? onClick : null} />
      </ListItem>
    );
  }
}

ListResult.defaultProps = {
  invalid: false,
  pendingDeletion: null,
  clickableInvalid: false,
  entailed: false,
  informationOnly: false
};

ListResult.propTypes = {
  invalid: PropTypes.bool,
  lang: PropTypes.string,
  informationOnly: PropTypes.bool,
  entailed: PropTypes.bool,
  clickableInvalid: PropTypes.bool,
  listSecondIcon: PropTypes.object,
  iri: PropTypes.string,
  pendingDeletion: PropTypes.bool,
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  additionalLabel: PropTypes.any,
  classes: PropTypes.object
};

export default withStyles(styles)(ListResult);